<template>
  <details class="undo-protocol-change">
    <summary>
      <lucide-icon :name="icon" />
      <span>{{ change.path }}</span>
    </summary>
    <pre v-if="'value' in change">{{ change.value }}</pre>
  </details>
</template>

<script setup lang="ts">
import { computed } from "vue";

import LucideIcon from "@core/ui/LucideIcon.vue";

import type { Operation } from "fast-json-patch";
const props = defineProps<{
  change: Operation
}>();

const icon = computed(() => {
  switch (props.change.op) {
    case "add":
      return "plus";
    case "remove":
      return "minus";
    case "replace":
      return "pencil";
    default:
      return "pencil";
  }
});
</script>

<style lang="scss">
.undo-protocol-change {
  margin: 0;
  width: 100%;
  min-width: max-content;

  summary {
    display: grid;
    grid-template-columns: 1em 1fr;
    gap: 0.25em;
    align-items: center;
    cursor: pointer;

    &::marker {
      display: none;
    }
  }

  pre {
    margin: 0;
    margin-left: 1em;
    padding: 0.25em;
    border: 1px solid var(--color-border);
    border-radius: 0.5em;
    background-color: var(--color-background);
  }
}
</style>